import React, { useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import img from "../Assets/rb_2148279041.png";
import { toast } from "react-toastify";
import { Create_Api } from "../ApiUrls";
import SEOData from "../Components/SEOData";
// import cal from "../Assets/cal (1).png";
// import social1 from "../Assets/social (1).png";
// import social2 from "../Assets/social (2).png";
// import social3 from "../Assets/social (3).png";
// import social4 from "../Assets/social (4).png";
// import social5 from "../Assets/social (5).png";

function Contact() {

  const [Name, setName] = useState('');
  const [Email, setEmail] = useState('');
  const [Number, setNumber] = useState('');
  const [Subject, setSubject] = useState('');
  const [Message, setMessage] = useState('');
  const [IsUploading, setIsUploading] = useState(false);

  const ContactUsForm = async () => {
    if (!Name) {
      toast.error('Name is required!');
      return;
    }
    if (!Email) {
      toast.error('Email is required!');
      return;
    }
    if (!Number) {
      toast.error('Number is required!');
      return;
    }
    if (!Subject) {
      toast.error('Subject is required!');
      return;
    }
    if (!Message) {
      toast.error('Message is required!');
      return;
    }
    try {
      let data = {
        Name,
        Email,
        Number,
        Subject,
        Message,
      }
      setIsUploading(true)
      const response = await Create_Api(`api/admin/AddContactUs`, data)
      console.log('Contact us Successfull:', response);
      toast.success(response?.message);
      setName('')
      setEmail('')
      setNumber('')
      setSubject('')
      setMessage('')
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      toast.error(error?.response?.data?.message);
      console.log(error)
    }
  }



  return (
    <>
      <Navbar />
      <SEOData PageName={'contact'} />
      <div className="banner2">
        <h4>Contact</h4>
        <h2>Contact Us</h2>
        <p>Home - Contact Us</p>
      </div>
      <div className="GetInTochToday">
        <div className="GetInTochToday-left">
          <h3>Get In Touch Today!</h3>
          <br />

          <br />
          <div className="call">
            <div>
              <div className="contact-icon">
                <i class="bi bi-telephone-fill"></i>
              </div>
            </div>

            <div>
              <h5>Call Me Now</h5>
              <p>+5896369785</p>
            </div>
          </div>
          <br />
          <br />

          <div className="call">
            <div className="contact-icon">
              <div className="contact-icon">
                <i class="bi bi-envelope-fill"></i>
              </div>
            </div>
            <div>
              <h5>Send Me</h5>
              <p>Copywriter@gmail.com</p>
            </div>
          </div>
          <br />
          <br />

          <div className="call">
            <div>
              <div className="contact-icon">
                <i class="bi bi-geo-alt-fill"></i>
              </div>
            </div>
            <div>
              <h5>Location</h5>
              <p>11 Koala Avenue, Sydney, NSW 2000, Australia</p>
            </div>
          </div>
        </div>
        <div className="GetInTochToday-right">
          <img src={img} />
        </div>
      </div>
      <div className="send-msg">
        <h2>Send a Message!</h2>
        <div className="send-contact">
          <div className="inps">
            <div className="inp">
              <label>Name</label>
              <input
                placeholder="Enter Name"
                value={Name}
                onChange={(e) => { setName(e.target.value) }}
              />
            </div>
            <div className="inp">
              <label>Email</label>
              <input
                placeholder="Enter Email"
                value={Email}
                onChange={(e) => { setEmail(e.target.value) }}
              />
            </div>
          </div>
          <br />
          <div className="inps">
            <div className="inp">
              <label>Number</label>
              <input placeholder="Enter Number"
                value={Number}
                onChange={(e) => { setNumber(e.target.value) }}
              />
            </div>
            <div className="inp">
              <label>Subject</label>
              <input placeholder="Enter Subject"
                value={Subject}
                onChange={(e) => { setSubject(e.target.value) }}
              />
            </div>
          </div>
          <br />
          <div className="inps">
            <div className="inp">
              <label>Message</label>
              <textarea
                placeholder="Enter Message"
                value={Message}
                onChange={(e) => { setMessage(e.target.value) }}
              />
            </div>
          </div>
          <br />
          <br />
          <button onClick={() => { ContactUsForm() }}>
            {IsUploading ? "Please Wait" : "Send"}
          </button>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Contact;
